import { render, staticRenderFns } from "./SetupServer.vue?vue&type=template&id=8fa7c964&scoped=true&"
import script from "./SetupServer.vue?vue&type=script&lang=js&"
export * from "./SetupServer.vue?vue&type=script&lang=js&"
import style0 from "./SetupServer.vue?vue&type=style&index=0&id=8fa7c964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa7c964",
  null
  
)

export default component.exports